module.exports = __webpack_public_path__ + "static/media/vierve.082c9dbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/res/entries/vierve.png
// module id = 1084
// module chunks = 0